var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dl',{staticClass:"nn-detail-cell flex justify-between items-center pt-4 pb-2",class:{
    'flex-col': _vm.col,
  }},[(_vm.label)?_c('dt',{},[_vm._v(" "+_vm._s(_vm.$t(_vm.label))+" ")]):_vm._e(),_c('dd',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }